import React from 'react';
import { useSelector } from 'react-redux';
import config from 'src/config/config';
import {
  dailyMaximums,
  DELIVERY_DIRECT_DEPOSIT,
  DELIVERY_EXPRESS_DELIVERY,
} from 'src/settings/settings';
import { appendBasePath } from 'src/utils/nav.utils';
import {
  isAutomaticSell,
  isCollegeDistribute,
} from 'src/utils/transactions-util';
import { currencyNoPrecision, getClientType } from 'src/utils/utils';
import If from '../../Shared/If/If';
import TRP from '../../Shared/TRP/TRP';
import './DailyMaximumText.scss';
import { get529MaximumAmount } from 'src/redux/modules/sellTransaction/sellTransaction.selectors';

const DailyMaximumText = ({
  isSalesforceRep,
  customerWebViewEnabled,
  deliveryMethod,
  personalData,
}) => {
  const client = getClientType(personalData.entitySegment);
  const dailyMaxAmount = currencyNoPrecision(dailyMaximums.transfer.all);
  const maxRedumption = useSelector(get529MaximumAmount);

  if (isCollegeDistribute() && deliveryMethod === DELIVERY_EXPRESS_DELIVERY) {
    return (
      <div className="e2e-daily-max-text-529-wire daily-max-text">
        The Plan does not assess any fees for this service; however, fees from
        your chosen bank may apply. Please contact your bank for this
        information. Proceeds will leave <TRP /> on the business day following
        the trade date. Generally, wire transfers are credited the same day, but
        the Plan cannot guarantee when your bank account will be credited. The
        maximum amount that may be distributed from a 529 account is{' '}
        {maxRedumption} per day.
      </div>
    );
  }

  return (
    <div className="e2e-daily-max-text daily-max-text">
      {!customerWebViewEnabled && isSalesforceRep ? (
        <span></span>
      ) : (
        <span>
          <div className="daily-max-text-add-bank-text">
            If you would like to{' '}
            <a
              className="text-nowrap college-branded-link"
              href={`${config.url}${appendBasePath('/addbank')}`}
            >
              add a bank
            </a>
            , please note that during the 5 calendar days following a newly
            added bank, proceeds from a redemption submitted online can only be
            sent by check or to a previously linked bank account.
          </div>
        </span>
      )}
      <If test={deliveryMethod === DELIVERY_DIRECT_DEPOSIT}>
        {!customerWebViewEnabled && isSalesforceRep ? (
          <span></span>
        ) : isCollegeDistribute() ? (
          <span>
            The maximum amount that may be distributed from a 529 account is
            {maxRedumption} per day.
          </span>
        ) : (
          <div>
            <br></br>
            The maximum redemption amount that may be requested online and sent
            to a bank (by ACH or wire transfer) is {dailyMaxAmount} combined per
            day.
          </div>
        )}
      </If>
      <If test={deliveryMethod === DELIVERY_EXPRESS_DELIVERY}>
        {!customerWebViewEnabled && isSalesforceRep ? (
          <span>
            Close this tool to add a new bank. There will be a five day hold on
            a newly added bank.
          </span>
        ) : (
          <span></span>
        )}
        <If test={client === 'core' || client === 'preferred'}>
          <span className="hidden-xs hidden-sm">
            Wire transfers are complimentary for transactions of $5,000 or more.
            Transactions less than $5,000, a $5 fee will be charged for each
            redeemed fund. Additional fees from your chosen bank may apply.{' '}
          </span>{' '}
          The maximum redemption amount that may be requested online and sent to
          a bank (by ACH or wire transfer) is{' '}
          {isAutomaticSell() ? '$25,000' : dailyMaxAmount} combined per day.
        </If>
        <If
          test={
            client === 'high_value' ||
            client === 'enhanced_personal' ||
            client === 'personal'
          }
        >
          <span className="hidden-xs hidden-sm">
            This service is offered complimentary to you. Additional fees from
            your chosen bank may apply.
          </span>{' '}
          The maximum redemption amount that may be requested online and sent to
          a bank (by ACH or wire transfer) is{' '}
          {isAutomaticSell() ? '$25,000' : dailyMaxAmount} combined per day.
        </If>
        {!customerWebViewEnabled && isSalesforceRep && (
          <span>
            {' '}
            Wire redemptions for more than one fund account must be done via the
            record keeper to avoid multiple charges.
          </span>
        )}
      </If>
    </div>
  );
};

export default DailyMaximumText;
